import logo from "assets/svg/logo.svg";
import React from 'react'

const FormLogo = () => {
  return (
    <img src={logo} alt="logo" className="mt-3 h-70--mob" />
  )
}

export default FormLogo